import { useState } from "react";
import Tooltip from "../tooltip/tooltip";

interface ActionButtonTooltipProps {
  text: string;
  onClick: () => void;
  className?: string;
  tooltipPosition?: "center" | "right" | "left";
  disabled?: boolean;
  children?: React.ReactNode;
}

const ActionButtonTooltip = ({
  text,
  onClick,
  className = "",
  tooltipPosition,
  disabled = false,
  children,
}: ActionButtonTooltipProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    // <div style={{ display: 'inline-block' }}>
    <button
      type="button"
      className={className}
      data-testid="action-button-tooltip"
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => !disabled && setIsTooltipVisible(true)}
      onMouseLeave={() => setIsTooltipVisible(false)}
    >
      <Tooltip isShown={isTooltipVisible} position={tooltipPosition}>
        {text}
      </Tooltip>
      {children}
    </button>
    // </div>
  );
};

export default ActionButtonTooltip;
